import { IIconProps } from './types';

/**
 * -----------------------------------------------------------------------------
 * It renders a notification icon with a bell shape.
 */
export function BellIcon({
  className,
  strokeWidth = 1,
  variant,
}: Readonly<IIconProps>) {
  if (variant !== 'solid') {
    return (
      <svg className={className} fill="none" viewBox="0 0 24 24">
        <path
          d="M14.857 17.082c1.863-.22 3.694-.66 5.454-1.31A8.967 8.967 0 0 1 18 9.75V9A6 6 0 0 0 6 9v.75a8.967 8.967 0 0 1-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.259 24.259 0 0 1-5.714 0m5.714 0a3 3 0 1 1-5.714 0"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth}
        />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24">
      <path
        clipRule="evenodd"
        d="M5.25 9a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 1 1-7.48 0 24.585 24.585 0 0 1-4.831-1.244.75.75 0 0 1-.298-1.205A8.217 8.217 0 0 0 5.25 9.75V9Zm4.502 8.9a2.25 2.25 0 1 0 4.496 0c-1.496.135-3 .135-4.496 0Z"
        fillRule="evenodd"
        strokeWidth={strokeWidth}
      />
    </svg>
  );
}
